import { render, staticRenderFns } from "./BasicSettings.vue?vue&type=template&id=342f3cae&scoped=true"
import script from "./BasicSettings.vue?vue&type=script&lang=js"
export * from "./BasicSettings.vue?vue&type=script&lang=js"
import style0 from "./BasicSettings.vue?vue&type=style&index=0&id=342f3cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342f3cae",
  null
  
)

export default component.exports